import createSelectors from 'app/lib/betting/betting-entities/selectors';

export const {
  delta,
  sports,
  sportIds,
  tournamentUnions,
  tournaments,
  tournamentStages,
  tournamentStageIds,
  matches,
  matchIds,
  objects,
  createMatchObjectsSelector,
  isMatchStarted,
  isLockedBet,
  entityLoading,
  entityRequested,
  entitySignature,
  getUnionsFromSportsSelector,
  getTournamentsFromSportsSelector,
  getTournamentsFromUnionsSelector,
  getStagesFromTournamentsSelector,
} = createSelectors(['prematch', 'entities', 'grid']);
